// depend
import TimeAgo from "timeago-react";
const TimeAgoCalc = ({ date }) => {
  return (
    <TimeAgo datetime={date} />
  )
}
export default TimeAgoCalc;